import { emptySplitApi as api } from './emptyApi';
export const addTagTypes = [
  'Authentication',
  'Backup',
  'BackupOperation',
  'DNS',
  'DeviceUpdate',
  'Diskinfo',
  'Firmware',
  'Info',
  'Issues',
  'License',
  'Load',
  'Login',
  'Modules',
  'Services',
  'ModulesDiskUsage',
  'Network',
  'PortAccess',
  'PowerManagement',
  'Roles',
  'Users',
  'ServicesBasic',
  'Time',
  'Tokens',
  'Upload',
  'Vtun',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: build => ({
      putProfile: build.mutation<PutProfileApiResponse, PutProfileApiArg>({
        query: queryArg => ({ url: `/profile`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Authentication'],
      }),
      getProfile: build.query<GetProfileApiResponse, GetProfileApiArg>({
        query: () => ({ url: `/profile` }),
        providesTags: ['Authentication'],
      }),
      postLogout: build.mutation<PostLogoutApiResponse, PostLogoutApiArg>({
        query: () => ({ url: `/logout`, method: 'POST' }),
        invalidatesTags: ['Authentication'],
      }),
      postBackup: build.mutation<PostBackupApiResponse, PostBackupApiArg>({
        query: () => ({ url: `/backup`, method: 'POST' }),
        invalidatesTags: ['Backup'],
      }),
      getBackup: build.query<GetBackupApiResponse, GetBackupApiArg>({
        query: () => ({ url: `/backup` }),
        providesTags: ['Backup'],
      }),
      postBackupByNameToken: build.mutation<PostBackupByNameTokenApiResponse, PostBackupByNameTokenApiArg>({
        query: queryArg => ({ url: `/backup/${queryArg.name}/token`, method: 'POST' }),
        invalidatesTags: ['Backup'],
      }),
      deleteBackupByName: build.mutation<DeleteBackupByNameApiResponse, DeleteBackupByNameApiArg>({
        query: queryArg => ({ url: `/backup/${queryArg.name}`, method: 'DELETE' }),
        invalidatesTags: ['Backup'],
      }),
      putBackupByName: build.mutation<PutBackupByNameApiResponse, PutBackupByNameApiArg>({
        query: queryArg => ({ url: `/backup/${queryArg.name}`, method: 'PUT' }),
        invalidatesTags: ['Backup'],
      }),
      postBackupByName: build.mutation<PostBackupByNameApiResponse, PostBackupByNameApiArg>({
        query: queryArg => ({ url: `/backup/${queryArg.name}`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Backup'],
      }),
      getBackupByNameDownload: build.query<GetBackupByNameDownloadApiResponse, GetBackupByNameDownloadApiArg>({
        query: queryArg => ({ url: `/backup/${queryArg.name}/download` }),
        providesTags: ['Backup'],
      }),
      getBackupUploadByIdStatus: build.query<GetBackupUploadByIdStatusApiResponse, GetBackupUploadByIdStatusApiArg>({
        query: queryArg => ({ url: `/backup/upload/${queryArg.id}/status` }),
        providesTags: ['Backup'],
      }),
      putBackupUploadByIdInterrupt: build.mutation<
        PutBackupUploadByIdInterruptApiResponse,
        PutBackupUploadByIdInterruptApiArg
      >({
        query: queryArg => ({ url: `/backup/upload/${queryArg.id}/interrupt`, method: 'PUT' }),
        invalidatesTags: ['Backup'],
      }),
      getBackupUploadByIdJoin: build.query<GetBackupUploadByIdJoinApiResponse, GetBackupUploadByIdJoinApiArg>({
        query: queryArg => ({ url: `/backup/upload/${queryArg.id}/join` }),
        providesTags: ['Backup'],
      }),
      getBackupUploadList: build.query<GetBackupUploadListApiResponse, GetBackupUploadListApiArg>({
        query: queryArg => ({
          url: `/backup/upload/list`,
          params: {
            active: queryArg.active,
          },
        }),
        providesTags: ['Backup'],
      }),
      postBackupOperationByKindDismiss: build.mutation<
        PostBackupOperationByKindDismissApiResponse,
        PostBackupOperationByKindDismissApiArg
      >({
        query: queryArg => ({ url: `/backup/operation/${queryArg.kind}/dismiss`, method: 'POST' }),
        invalidatesTags: ['BackupOperation'],
      }),
      getBackupOperation: build.query<GetBackupOperationApiResponse, GetBackupOperationApiArg>({
        query: () => ({ url: `/backup/operation` }),
        providesTags: ['BackupOperation'],
      }),
      deleteBackupByTokenDownloadByName: build.mutation<
        DeleteBackupByTokenDownloadByNameApiResponse,
        DeleteBackupByTokenDownloadByNameApiArg
      >({
        query: queryArg => ({ url: `/backup/${queryArg.token}/download/${queryArg.name}`, method: 'DELETE' }),
        invalidatesTags: ['Backup'],
      }),
      postBackupUploadLink: build.mutation<PostBackupUploadLinkApiResponse, PostBackupUploadLinkApiArg>({
        query: queryArg => ({ url: `/backup/upload/link`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Backup'],
      }),
      getDns: build.query<GetDnsApiResponse, GetDnsApiArg>({
        query: () => ({ url: `/dns` }),
        providesTags: ['DNS'],
      }),
      putDns: build.mutation<PutDnsApiResponse, PutDnsApiArg>({
        query: queryArg => ({ url: `/dns`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['DNS'],
      }),
      getDnsOverrides: build.query<GetDnsOverridesApiResponse, GetDnsOverridesApiArg>({
        query: () => ({ url: `/dns/overrides` }),
        providesTags: ['DNS'],
      }),
      putDnsOverrides: build.mutation<PutDnsOverridesApiResponse, PutDnsOverridesApiArg>({
        query: queryArg => ({ url: `/dns/overrides`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['DNS'],
      }),
      getDeviceUpdateFirmware: build.query<GetDeviceUpdateFirmwareApiResponse, GetDeviceUpdateFirmwareApiArg>({
        query: () => ({ url: `/device-update/firmware` }),
        providesTags: ['DeviceUpdate'],
      }),
      getDeviceUpdateLauncher: build.query<GetDeviceUpdateLauncherApiResponse, GetDeviceUpdateLauncherApiArg>({
        query: () => ({ url: `/device-update/launcher` }),
        providesTags: ['DeviceUpdate'],
      }),
      getDiskinfo: build.query<GetDiskinfoApiResponse, GetDiskinfoApiArg>({
        query: () => ({ url: `/diskinfo` }),
        providesTags: ['Diskinfo'],
      }),
      deleteFirmwareByName: build.mutation<DeleteFirmwareByNameApiResponse, DeleteFirmwareByNameApiArg>({
        query: queryArg => ({ url: `/firmware/${queryArg.name}`, method: 'DELETE' }),
        invalidatesTags: ['Firmware'],
      }),
      putFirmwareByName: build.mutation<PutFirmwareByNameApiResponse, PutFirmwareByNameApiArg>({
        query: queryArg => ({ url: `/firmware/${queryArg.name}`, method: 'PUT' }),
        invalidatesTags: ['Firmware', 'Info'],
      }),
      getFirmware: build.query<GetFirmwareApiResponse, GetFirmwareApiArg>({
        query: () => ({ url: `/firmware` }),
        providesTags: ['Firmware'],
      }),
      getFirmwareUploadByIdStatus: build.query<
        GetFirmwareUploadByIdStatusApiResponse,
        GetFirmwareUploadByIdStatusApiArg
      >({
        query: queryArg => ({ url: `/firmware/upload/${queryArg.id}/status` }),
        providesTags: ['Firmware'],
      }),
      putFirmwareUploadByIdInterrupt: build.mutation<
        PutFirmwareUploadByIdInterruptApiResponse,
        PutFirmwareUploadByIdInterruptApiArg
      >({
        query: queryArg => ({ url: `/firmware/upload/${queryArg.id}/interrupt`, method: 'PUT' }),
        invalidatesTags: ['Firmware'],
      }),
      getFirmwareUploadByIdJoin: build.query<GetFirmwareUploadByIdJoinApiResponse, GetFirmwareUploadByIdJoinApiArg>({
        query: queryArg => ({ url: `/firmware/upload/${queryArg.id}/join` }),
        providesTags: ['Firmware'],
      }),
      getFirmwareUploadList: build.query<GetFirmwareUploadListApiResponse, GetFirmwareUploadListApiArg>({
        query: queryArg => ({
          url: `/firmware/upload/list`,
          params: {
            active: queryArg.active,
          },
        }),
        providesTags: ['Firmware'],
      }),
      postFirmwareUploadByName: build.mutation<PostFirmwareUploadByNameApiResponse, PostFirmwareUploadByNameApiArg>({
        query: queryArg => ({ url: `/firmware/upload/${queryArg.name}`, method: 'POST' }),
        invalidatesTags: ['Firmware'],
      }),
      postFirmwareLink: build.mutation<PostFirmwareLinkApiResponse, PostFirmwareLinkApiArg>({
        query: queryArg => ({ url: `/firmware/link`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Firmware'],
      }),
      getInfo: build.query<GetInfoApiResponse, GetInfoApiArg>({
        query: () => ({ url: `/info` }),
        providesTags: ['Info'],
      }),
      getInfoBasic: build.query<GetInfoBasicApiResponse, GetInfoBasicApiArg>({
        query: () => ({ url: `/info/basic` }),
        providesTags: ['Info'],
      }),
      putInfoAlias: build.mutation<PutInfoAliasApiResponse, PutInfoAliasApiArg>({
        query: queryArg => ({ url: `/info/alias`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Info'],
      }),
      getIssues: build.query<GetIssuesApiResponse, GetIssuesApiArg>({
        query: () => ({ url: `/issues` }),
        providesTags: ['Issues'],
      }),
      getLicense: build.query<GetLicenseApiResponse, GetLicenseApiArg>({
        query: () => ({ url: `/license` }),
        providesTags: ['License'],
      }),
      postLicense: build.mutation<PostLicenseApiResponse, PostLicenseApiArg>({
        query: queryArg => ({ url: `/license`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['License'],
      }),
      getLoad: build.query<GetLoadApiResponse, GetLoadApiArg>({
        query: () => ({ url: `/load` }),
        providesTags: ['Load'],
      }),
      postLogin: build.mutation<PostLoginApiResponse, PostLoginApiArg>({
        query: queryArg => ({ url: `/login`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Login'],
      }),
      deleteModulesById: build.mutation<DeleteModulesByIdApiResponse, DeleteModulesByIdApiArg>({
        query: queryArg => ({ url: `/modules/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Modules'],
      }),
      putModulesById: build.mutation<PutModulesByIdApiResponse, PutModulesByIdApiArg>({
        query: queryArg => ({ url: `/modules/${queryArg.id}`, method: 'PUT' }),
        invalidatesTags: ['Modules', 'Services'],
      }),
      deleteModulesByNameUpdateError: build.mutation<
        DeleteModulesByNameUpdateErrorApiResponse,
        DeleteModulesByNameUpdateErrorApiArg
      >({
        query: queryArg => ({ url: `/modules/${queryArg.name}/update-error`, method: 'DELETE' }),
        invalidatesTags: ['Modules'],
      }),
      getModulesDiskUsage: build.query<GetModulesDiskUsageApiResponse, GetModulesDiskUsageApiArg>({
        query: () => ({ url: `/modules/disk-usage` }),
        providesTags: ['Modules', 'ModulesDiskUsage'],
      }),
      getModulesUploadByIdStatus: build.query<GetModulesUploadByIdStatusApiResponse, GetModulesUploadByIdStatusApiArg>({
        query: queryArg => ({ url: `/modules/upload/${queryArg.id}/status` }),
        providesTags: ['Modules'],
      }),
      getModules: build.query<GetModulesApiResponse, GetModulesApiArg>({
        query: () => ({ url: `/modules` }),
        providesTags: ['Modules'],
      }),
      postModules: build.mutation<PostModulesApiResponse, PostModulesApiArg>({
        query: queryArg => ({ url: `/modules`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Modules'],
      }),
      putModulesUploadByIdInterrupt: build.mutation<
        PutModulesUploadByIdInterruptApiResponse,
        PutModulesUploadByIdInterruptApiArg
      >({
        query: queryArg => ({ url: `/modules/upload/${queryArg.id}/interrupt`, method: 'PUT' }),
        invalidatesTags: ['Modules'],
      }),
      getModulesUploadByIdJoin: build.query<GetModulesUploadByIdJoinApiResponse, GetModulesUploadByIdJoinApiArg>({
        query: queryArg => ({ url: `/modules/upload/${queryArg.id}/join` }),
        providesTags: ['Modules'],
      }),
      getModulesUploadList: build.query<GetModulesUploadListApiResponse, GetModulesUploadListApiArg>({
        query: queryArg => ({
          url: `/modules/upload/list`,
          params: {
            active: queryArg.active,
          },
        }),
        providesTags: ['Modules'],
      }),
      postModulesLink: build.mutation<PostModulesLinkApiResponse, PostModulesLinkApiArg>({
        query: queryArg => ({ url: `/modules/link`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Modules'],
      }),
      postNetworkAccept: build.mutation<PostNetworkAcceptApiResponse, PostNetworkAcceptApiArg>({
        query: () => ({ url: `/network/accept`, method: 'POST' }),
        invalidatesTags: ['Network'],
      }),
      postNetworkDecline: build.mutation<PostNetworkDeclineApiResponse, PostNetworkDeclineApiArg>({
        query: () => ({ url: `/network/decline`, method: 'POST' }),
        invalidatesTags: ['Network'],
      }),
      getNetwork: build.query<GetNetworkApiResponse, GetNetworkApiArg>({
        query: () => ({ url: `/network` }),
        providesTags: ['Network'],
      }),
      putNetwork: build.mutation<PutNetworkApiResponse, PutNetworkApiArg>({
        query: queryArg => ({ url: `/network`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Network'],
      }),
      putNetworkTryByDelay: build.mutation<PutNetworkTryByDelayApiResponse, PutNetworkTryByDelayApiArg>({
        query: queryArg => ({ url: `/network/try/${queryArg.delay}`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Network'],
      }),
      putNetworkTry: build.mutation<PutNetworkTryApiResponse, PutNetworkTryApiArg>({
        query: queryArg => ({ url: `/network/try`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Network'],
      }),
      getPortAccess: build.query<GetPortAccessApiResponse, GetPortAccessApiArg>({
        query: () => ({ url: `/port-access` }),
        providesTags: ['PortAccess'],
      }),
      putPortAccess: build.mutation<PutPortAccessApiResponse, PutPortAccessApiArg>({
        query: queryArg => ({ url: `/port-access`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['PortAccess'],
      }),
      postPoweroff: build.mutation<PostPoweroffApiResponse, PostPoweroffApiArg>({
        query: () => ({ url: `/poweroff`, method: 'POST' }),
        invalidatesTags: ['PowerManagement'],
      }),
      postReboot: build.mutation<PostRebootApiResponse, PostRebootApiArg>({
        query: () => ({ url: `/reboot`, method: 'POST' }),
        invalidatesTags: ['PowerManagement'],
      }),
      postRoleGrantsByRole: build.mutation<PostRoleGrantsByRoleApiResponse, PostRoleGrantsByRoleApiArg>({
        query: queryArg => ({ url: `/role/grants/${queryArg.role}`, method: 'POST' }),
        invalidatesTags: ['Roles'],
      }),
      deleteRoleGrantsByRole: build.mutation<DeleteRoleGrantsByRoleApiResponse, DeleteRoleGrantsByRoleApiArg>({
        query: queryArg => ({ url: `/role/grants/${queryArg.role}`, method: 'DELETE' }),
        invalidatesTags: ['Roles', 'Users'],
      }),
      putRoleGrantsByRole: build.mutation<PutRoleGrantsByRoleApiResponse, PutRoleGrantsByRoleApiArg>({
        query: queryArg => ({ url: `/role/grants/${queryArg.role}`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Roles'],
      }),
      getRoleAvailableModules: build.query<GetRoleAvailableModulesApiResponse, GetRoleAvailableModulesApiArg>({
        query: () => ({ url: `/role/available-modules` }),
        providesTags: ['Roles'],
      }),
      getRole: build.query<GetRoleApiResponse, GetRoleApiArg>({
        query: () => ({ url: `/role` }),
        providesTags: ['Roles'],
      }),
      deleteServicesById: build.mutation<DeleteServicesByIdApiResponse, DeleteServicesByIdApiArg>({
        query: queryArg => ({ url: `/services/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Services', 'Modules'],
      }),
      getServices: build.query<GetServicesApiResponse, GetServicesApiArg>({
        query: () => ({ url: `/services` }),
        providesTags: ['Services'],
      }),
      getServicesBasic: build.query<GetServicesBasicApiResponse, GetServicesBasicApiArg>({
        query: () => ({ url: `/services/basic` }),
        providesTags: ['Services', 'ServicesBasic'],
      }),
      putServicesByIdByCommand: build.mutation<PutServicesByIdByCommandApiResponse, PutServicesByIdByCommandApiArg>({
        query: queryArg => ({ url: `/services/${queryArg.id}/${queryArg.command}`, method: 'PUT' }),
        invalidatesTags: ['Services'],
      }),
      postTimeNtpByHost: build.mutation<PostTimeNtpByHostApiResponse, PostTimeNtpByHostApiArg>({
        query: queryArg => ({ url: `/time/ntp/${queryArg.host}`, method: 'POST' }),
        invalidatesTags: ['Time'],
      }),
      deleteTimeNtpByHost: build.mutation<DeleteTimeNtpByHostApiResponse, DeleteTimeNtpByHostApiArg>({
        query: queryArg => ({ url: `/time/ntp/${queryArg.host}`, method: 'DELETE' }),
        invalidatesTags: ['Time'],
      }),
      getTime: build.query<GetTimeApiResponse, GetTimeApiArg>({
        query: () => ({ url: `/time` }),
        providesTags: ['Time'],
      }),
      getTimeTimezoneList: build.query<GetTimeTimezoneListApiResponse, GetTimeTimezoneListApiArg>({
        query: () => ({ url: `/time/timezone/list` }),
        providesTags: ['Time'],
      }),
      putTimeDatetime: build.mutation<PutTimeDatetimeApiResponse, PutTimeDatetimeApiArg>({
        query: queryArg => ({ url: `/time/datetime`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Time'],
      }),
      putTimeTimezone: build.mutation<PutTimeTimezoneApiResponse, PutTimeTimezoneApiArg>({
        query: queryArg => ({ url: `/time/timezone`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Time'],
      }),
      putTimeNtpServerByState: build.mutation<PutTimeNtpServerByStateApiResponse, PutTimeNtpServerByStateApiArg>({
        query: queryArg => ({ url: `/time/ntp-server/${queryArg.state}`, method: 'PUT' }),
        invalidatesTags: ['Time'],
      }),
      putTimeNtpByState: build.mutation<PutTimeNtpByStateApiResponse, PutTimeNtpByStateApiArg>({
        query: queryArg => ({ url: `/time/ntp/${queryArg.state}`, method: 'PUT' }),
        invalidatesTags: ['Time'],
      }),
      postTokens: build.mutation<PostTokensApiResponse, PostTokensApiArg>({
        query: queryArg => ({ url: `/tokens`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Tokens'],
      }),
      getTokens: build.query<GetTokensApiResponse, GetTokensApiArg>({
        query: () => ({ url: `/tokens` }),
        providesTags: ['Tokens'],
      }),
      deleteTokensById: build.mutation<DeleteTokensByIdApiResponse, DeleteTokensByIdApiArg>({
        query: queryArg => ({ url: `/tokens/${queryArg.id}`, method: 'DELETE' }),
        invalidatesTags: ['Tokens'],
      }),
      putTokensById: build.mutation<PutTokensByIdApiResponse, PutTokensByIdApiArg>({
        query: queryArg => ({ url: `/tokens/${queryArg.id}`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Tokens'],
      }),
      postUploadProbeLink: build.mutation<PostUploadProbeLinkApiResponse, PostUploadProbeLinkApiArg>({
        query: queryArg => ({ url: `/upload/probe-link`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Upload'],
      }),
      postUser: build.mutation<PostUserApiResponse, PostUserApiArg>({
        query: queryArg => ({ url: `/user`, method: 'POST', body: queryArg.body }),
        invalidatesTags: ['Users'],
      }),
      deleteUser: build.mutation<DeleteUserApiResponse, DeleteUserApiArg>({
        query: queryArg => ({ url: `/user`, method: 'DELETE', body: queryArg.body }),
        invalidatesTags: ['Users'],
      }),
      getUser: build.query<GetUserApiResponse, GetUserApiArg>({
        query: () => ({ url: `/user` }),
        providesTags: ['Users'],
      }),
      putUser: build.mutation<PutUserApiResponse, PutUserApiArg>({
        query: queryArg => ({ url: `/user`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Users', 'Issues'],
      }),
      putUserByUsernamePermissions: build.mutation<
        PutUserByUsernamePermissionsApiResponse,
        PutUserByUsernamePermissionsApiArg
      >({
        query: queryArg => ({ url: `/user/${queryArg.username}/permissions`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Users'],
      }),
      getVtun: build.query<GetVtunApiResponse, GetVtunApiArg>({
        query: () => ({ url: `/vtun` }),
        providesTags: ['Vtun'],
      }),
      putVtun: build.mutation<PutVtunApiResponse, PutVtunApiArg>({
        query: queryArg => ({ url: `/vtun`, method: 'PUT', body: queryArg.body }),
        invalidatesTags: ['Vtun', 'Network'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as api };
export type PutProfileApiResponse = /** status 200 OK */ boolean;
export type PutProfileApiArg = {
  body: {
    /** Old password */
    password: string;
    /** Password to be set */
    newPassword: string;
  };
};
export type GetProfileApiResponse = /** status 200 OK */ {
  /** Username */
  username: string;
  /** List of roles */
  roles: string[];
  /** Per-user module grants (independent of roles) */
  modules: string[];
  /** Per-user resource grants (independent of roles) */
  grants: {
    [key: string]: {
      /** Whether the user has read access to the resource */
      read?: boolean;
      /** Whether the user has write access to the resource */
      write?: boolean;
    };
  };
  /** Effective permissions, resources merged from roles and per-user grants */
  permissions: {
    /** Modules the user may open, keyed by module name */
    moduleAccess: {
      [key: string]: unknown;
    };
    [key: string]:
      | (
          | {
              /** Whether the user has read access to the resource */
              read?: boolean;
              /** Whether the user has write access to the resource */
              write?: boolean;
            }
          | {
              [key: string]: unknown;
            }
        )
      | {
          [key: string]: unknown;
        };
  };
  /** Interface this session came in through */
  currentIface?: string;
};
export type GetProfileApiArg = void;
export type PostLogoutApiResponse = unknown;
export type PostLogoutApiArg = void;
export type PostBackupApiResponse = /** status 200 OK */ {
  [key: string]: unknown;
};
export type PostBackupApiArg = void;
export type GetBackupApiResponse = /** status 200 OK */ BackupItem[];
export type GetBackupApiArg = void;
export type PostBackupByNameTokenApiResponse = /** status 200 OK */ {
  /** Download link URI */
  uri: string;
};
export type PostBackupByNameTokenApiArg = {
  name: string;
};
export type DeleteBackupByNameApiResponse = /** status 200 OK */ {
  /** Backup filename */
  filename: string;
  /** File statistics */
  stat: {
    /** File creation time (ISO 8601) */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the backup was created manually */
  isManual: boolean;
};
export type DeleteBackupByNameApiArg = {
  name: string;
};
export type PutBackupByNameApiResponse = /** status 200 OK */ {
  [key: string]: unknown;
};
export type PutBackupByNameApiArg = {
  name: string;
};
export type PostBackupByNameApiResponse = /** status 200 OK */ {
  /** Backup filename */
  filename: string;
  /** File statistics */
  stat: {
    /** File creation time (ISO 8601) */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the backup was created manually */
  isManual: boolean;
};
export type PostBackupByNameApiArg = {
  name: string;
  body: Blob;
};
export type GetBackupByNameDownloadApiResponse = unknown;
export type GetBackupByNameDownloadApiArg = {
  /** backup name */
  name: string;
};
export type GetBackupUploadByIdStatusApiResponse = /** status 200 OK */ {
  /** Upload progress info */
  info: {
    /** Bytes received */
    received: number;
    /** Total bytes estimated */
    estimated: number;
    /** Whether upload is complete */
    uploadFinished: boolean;
  };
  /** Upload metadata */
  meta: {
    /** Source URI (for link uploads) */
    uri?: string;
    /** Whether upload was via POST */
    post: boolean;
    /** Backup filename */
    filename: string;
    /** Partial file path */
    partial: string;
  };
  /** Upload operation ID */
  id: string;
  /** Upload status */
  status: 'PROCESSING' | 'RESOLVED' | 'REJECTED' | 'NOT_FOUND';
  /** Error details (when status is REJECTED) */
  error?: {
    /** Error message */
    message?: string;
    /** Error type */
    type?: string;
  };
  /** Backup filename (when status is RESOLVED) */
  value?: string;
};
export type GetBackupUploadByIdStatusApiArg = {
  /** upload id */
  id: string;
};
export type PutBackupUploadByIdInterruptApiResponse = /** status 200 OK */ boolean;
export type PutBackupUploadByIdInterruptApiArg = {
  id: string;
};
export type GetBackupUploadByIdJoinApiResponse = /** status 200 OK */ {
  /** Backup filename */
  filename: string;
  /** File statistics */
  stat: {
    /** File creation time (ISO 8601) */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the backup was created manually */
  isManual: boolean;
};
export type GetBackupUploadByIdJoinApiArg = {
  /** upload id */
  id: string;
};
export type GetBackupUploadListApiResponse = /** status 200 OK */ {
  /** Upload progress info */
  info: {
    /** Bytes received */
    received: number;
    /** Total bytes estimated */
    estimated: number;
    /** Whether upload is complete */
    uploadFinished: boolean;
  };
  /** Upload metadata */
  meta: {
    /** Source URI (for link uploads) */
    uri?: string;
    /** Whether upload was via POST */
    post: boolean;
    /** Backup filename */
    filename: string;
    /** Partial file path */
    partial: string;
  };
  /** Upload operation ID */
  id: string;
  /** Upload status */
  status: 'PROCESSING' | 'RESOLVED' | 'REJECTED' | 'NOT_FOUND';
}[];
export type GetBackupUploadListApiArg = {
  /** if set and equals to 'true' only active uploads are listed */
  active?: string;
};
export type PostBackupOperationByKindDismissApiResponse = /** status 200 OK */ {
  [key: string]: unknown;
};
export type PostBackupOperationByKindDismissApiArg = {
  kind: string;
};
export type GetBackupOperationApiResponse = /** status 200 OK */ {
  /** Current operation or null */
  current: {
    /** Operation kind */
    kind: 'create' | 'restore';
    /** Current phase */
    phase: 'COLLECTING' | 'COMPRESSING' | 'EXTRACTING' | 'RESTORING' | 'REBOOTING' | 'ERROR';
    /** Human-readable current step */
    detail?: string;
  } | null;
};
export type GetBackupOperationApiArg = void;
export type DeleteBackupByTokenDownloadByNameApiResponse = /** status 200 OK */ boolean;
export type DeleteBackupByTokenDownloadByNameApiArg = {
  token: string;
  name: string;
};
export type PostBackupUploadLinkApiResponse = /** status 200 OK */ {
  /** Upload operation ID */
  id: string;
};
export type PostBackupUploadLinkApiArg = {
  body: {
    /** uri to download */
    link: string;
  };
};
export type GetDnsApiResponse = /** status 200 OK */ string[];
export type GetDnsApiArg = void;
export type PutDnsApiResponse = /** status 200 OK */ string[];
export type PutDnsApiArg = {
  body: string[];
};
export type GetDnsOverridesApiResponse = /** status 200 OK */ {
  /** Firmware builds the override zone from configuration */
  supported: boolean;
  /** Overrides shipped with the firmware, read-only */
  factory: {
    /** Overridden domain name */
    name: string;
    /** Target IPv4 address or domain name */
    value: string;
  }[];
  /** User defined overrides */
  custom: {
    /** Overridden domain name */
    name: string;
    /** Target IPv4 address or domain name */
    value: string;
  }[];
};
export type GetDnsOverridesApiArg = void;
export type PutDnsOverridesApiResponse = /** status 200 OK */ {
  /** Firmware builds the override zone from configuration */
  supported: boolean;
  /** Overrides shipped with the firmware, read-only */
  factory: {
    /** Overridden domain name */
    name: string;
    /** Target IPv4 address or domain name */
    value: string;
  }[];
  /** User defined overrides */
  custom: {
    /** Overridden domain name */
    name: string;
    /** Target IPv4 address or domain name */
    value: string;
  }[];
};
export type PutDnsOverridesApiArg = {
  body: {
    overrides: {
      /** Overridden domain name */
      name: string;
      /** Target IPv4 address or domain name */
      value: string;
    }[];
  };
};
export type GetDeviceUpdateFirmwareApiResponse = unknown;
export type GetDeviceUpdateFirmwareApiArg = void;
export type GetDeviceUpdateLauncherApiResponse = unknown;
export type GetDeviceUpdateLauncherApiArg = void;
export type GetDiskinfoApiResponse = /** status 200 OK */ {
  /** Mountpoints keyed by device path */
  mountpoints: {
    [key: string]: {
      /** Device major:minor number */
      'maj:min': string;
      /** Mountpoint path */
      mountpoint: string;
      /** Device type */
      type: string;
      /** Raw lsblk output */
      lsblk: string;
      /** Disk usage info */
      usage: {
        /** Total size in KB */
        size: number;
        /** Used space in KB */
        used: number;
        /** Usage percentage */
        usage: number;
        /** Available space in KB */
        available: number;
      };
    };
  };
  /** SMART data keyed by device path */
  smart: {
    [key: string]: {
      /** SMART health status */
      health: string;
      /** SMART attributes */
      attributes: {
        /** Attribute name */
        attr: string;
        /** Attribute ID */
        id: number;
        /** Attribute flags */
        flags: string;
        /** Attribute value */
        value: string;
        /** Worst value */
        worst: string;
        /** Threshold value */
        thresh: string;
        /** Fail indicator */
        fail: string;
        /** Raw value */
        raw: number;
      }[];
      /** Device information */
      info: {
        /** Model family */
        model_family: string;
        /** Device model */
        device_model: string;
        /** Serial number */
        serial_number: string;
        /** Firmware version */
        firmware_version: string;
        /** User capacity */
        user_capacity: string;
        /** Rotation rate */
        rotation_rate: string;
      };
    };
  };
  /** Raw /proc/mdstat content */
  mdstat: string;
  /** MD array health keyed by device name */
  mdhealth: {
    [key: string]: {
      /** Number of degraded disks */
      degraded: number;
      /** Array state */
      arrayState: string;
    };
  };
  /** Physical disks discovered via hardware probe */
  hardware: {
    /** Disk serial number */
    serial: string;
    /** Disk size in bytes */
    size: number;
    /** Disk model */
    model: string;
    /** Disk device name (e.g. sda) */
    name: string;
  }[];
};
export type GetDiskinfoApiArg = void;
export type DeleteFirmwareByNameApiResponse = unknown;
export type DeleteFirmwareByNameApiArg = {
  name: string;
};
export type PutFirmwareByNameApiResponse = /** status 200 OK */ {
  /** Firmware filename */
  filename: string;
  /** File statistics (absent for corrupted firmware) */
  stat?: {
    /** Creation time */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the firmware is corrupted */
  corrupted: boolean;
  /** Error message (set only when corrupted) */
  error?: string;
  /** Firmware information (parsed from firmware archive's info file; absent for corrupted firmware; all fields are optional and best-effort) */
  info?: {
    /** System sources revision: "<sha> <branch> <build_url>" */
    firmware_revision?: string;
    /** Full firmware version (e.g. "trunk.71") */
    firmware_version?: string;
    /** Kernel revision: "<sha> <branch> <build_url>" */
    firmware_kernel_revision?: string;
    /** lcdproc revision: "<sha> <branch> <build_url>" */
    firmware_lcdproc_revision?: string;
    /** Squashfs MD5 checksum */
    md5sum?: string;
    /** Kernel image MD5 checksum */
    kernelmd5?: string;
    /** initrd image MD5 checksum */
    initrdmd5?: string;
    /** Firmware version (e.g. "trunk.71") */
    version?: string;
    /** Firmware type (e.g. "iptv") */
    type?: string;
    /** Source revision (build number) */
    revision?: string;
    /** Build date (ISO 8601) */
    date?: string;
    /** Kernel version (e.g. "4.4.129") */
    kernel_version?: string;
  };
  /** Modules information (absent for corrupted firmware; key — module name) */
  modules?: {
    [key: string]: {
      /** Module version/branch */
      version?: string;
      /** Build number (Jenkins) */
      build?: string;
      /** Commit SHA */
      revision?: string;
      /** Build time (ISO 8601) */
      build_datetime?: string;
      /** Jenkins build URL */
      build_url?: string;
    };
  };
};
export type PutFirmwareByNameApiArg = {
  name: string;
};
export type GetFirmwareApiResponse = /** status 200 OK */ FirmwareItem[];
export type GetFirmwareApiArg = void;
export type GetFirmwareUploadByIdStatusApiResponse = /** status 200 OK */ {
  info: {
    /** Current upload phase */
    phase?: string;
    /** Bytes received */
    received?: number;
    /** Total bytes estimated */
    estimated?: number;
    /** Whether upload is complete */
    uploadFinished?: boolean;
  } | null;
  meta: {
    /** Source URI (only for uploads by link) */
    uri?: string;
    /** Whether uploaded via POST */
    post: boolean;
    /** Firmware filename */
    filename: string;
    /** Partial upload identifier */
    partial: string;
  } | null;
  /** Upload status */
  status: 'PROCESSING' | 'RESOLVED' | 'REJECTED' | 'NOT_FOUND';
  /** Error details (when status is REJECTED) */
  error?: {
    /** Error message */
    message?: string;
    /** Error type */
    type?: string;
  };
  /** Firmware model (when status is RESOLVED) */
  value?: {
    /** Firmware filename */
    filename: string;
    /** File statistics (absent for corrupted firmware) */
    stat?: {
      /** Creation time */
      ctime: string;
      /** File size in bytes */
      size: number;
    };
    /** Firmware information (absent for corrupted firmware; all fields are optional and best-effort) */
    info?: {
      /** System sources revision */
      firmware_revision?: string;
      /** Full firmware version */
      firmware_version?: string;
      /** Kernel revision */
      firmware_kernel_revision?: string;
      /** lcdproc revision */
      firmware_lcdproc_revision?: string;
      /** Squashfs MD5 checksum */
      md5sum?: string;
      /** Kernel image MD5 checksum */
      kernelmd5?: string;
      /** Initrd image MD5 checksum */
      initrdmd5?: string;
      /** Firmware version */
      version?: string;
      /** Firmware type */
      type?: string;
      /** Source revision (build number) */
      revision?: string;
      /** Build date */
      date?: string;
      /** Kernel version */
      kernel_version?: string;
    };
    /** Modules information (absent for corrupted firmware; key — module name) */
    modules?: {
      [key: string]: {
        /** Module version/branch */
        version?: string;
        /** Build number (Jenkins) */
        build?: string;
        /** Commit SHA */
        revision?: string;
        /** Build time */
        build_datetime?: string;
        /** Jenkins build URL */
        build_url?: string;
      };
    };
    /** Whether the firmware is corrupted (absent for valid firmware) */
    corrupted?: boolean;
    /** Error message (set only when corrupted) */
    error?: string;
  };
};
export type GetFirmwareUploadByIdStatusApiArg = {
  /** upload id */
  id: string;
};
export type PutFirmwareUploadByIdInterruptApiResponse = /** status 200 OK */ boolean;
export type PutFirmwareUploadByIdInterruptApiArg = {
  id: string;
};
export type GetFirmwareUploadByIdJoinApiResponse = /** status 200 OK */ {
  /** Firmware filename */
  filename: string;
  /** File statistics (absent for corrupted firmware) */
  stat?: {
    /** Creation time */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the firmware is corrupted */
  corrupted: boolean;
  /** Error message (set only when corrupted) */
  error?: string;
  /** Firmware information (parsed from firmware archive's info file; absent for corrupted firmware; all fields are optional and best-effort) */
  info?: {
    /** System sources revision: "<sha> <branch> <build_url>" */
    firmware_revision?: string;
    /** Full firmware version (e.g. "trunk.71") */
    firmware_version?: string;
    /** Kernel revision: "<sha> <branch> <build_url>" */
    firmware_kernel_revision?: string;
    /** lcdproc revision: "<sha> <branch> <build_url>" */
    firmware_lcdproc_revision?: string;
    /** Squashfs MD5 checksum */
    md5sum?: string;
    /** Kernel image MD5 checksum */
    kernelmd5?: string;
    /** initrd image MD5 checksum */
    initrdmd5?: string;
    /** Firmware version (e.g. "trunk.71") */
    version?: string;
    /** Firmware type (e.g. "iptv") */
    type?: string;
    /** Source revision (build number) */
    revision?: string;
    /** Build date (ISO 8601) */
    date?: string;
    /** Kernel version (e.g. "4.4.129") */
    kernel_version?: string;
  };
  /** Modules information (absent for corrupted firmware; key — module name) */
  modules?: {
    [key: string]: {
      /** Module version/branch */
      version?: string;
      /** Build number (Jenkins) */
      build?: string;
      /** Commit SHA */
      revision?: string;
      /** Build time (ISO 8601) */
      build_datetime?: string;
      /** Jenkins build URL */
      build_url?: string;
    };
  };
};
export type GetFirmwareUploadByIdJoinApiArg = {
  /** upload id */
  id: string;
};
export type GetFirmwareUploadListApiResponse = /** status 200 OK */ {
  /** Upload progress info */
  info: {
    /** Bytes received */
    received: number;
    /** Total bytes estimated */
    estimated: number;
    /** Whether upload is complete */
    uploadFinished: boolean;
  };
  /** Upload metadata */
  meta: {
    /** Source URI */
    uri: string;
    /** Whether uploaded via POST */
    post: boolean;
    /** Firmware filename */
    filename: string;
    /** Partial upload identifier */
    partial: string;
  };
  /** Upload identifier */
  id: string;
  /** Upload status */
  status: 'PROCESSING' | 'RESOLVED' | 'REJECTED' | 'NOT_FOUND';
}[];
export type GetFirmwareUploadListApiArg = {
  /** if set and equals to 'true' only active uploads are listed */
  active?: string;
};
export type PostFirmwareUploadByNameApiResponse = /** status 200 OK */ {
  /** Upload identifier */
  id: string;
};
export type PostFirmwareUploadByNameApiArg = {
  name: string;
};
export type PostFirmwareLinkApiResponse = /** status 200 OK */ {
  /** Upload identifier */
  id: string;
};
export type PostFirmwareLinkApiArg = {
  body: {
    /** uri to download */
    link: string;
  };
};
export type GetInfoApiResponse = /** status 200 OK */ {
  /** Build information from /mnt/flash/info */
  build: {
    /** Firmware version */
    version: string;
    /** Firmware type */
    type: string;
    /** Source revision */
    revision: string;
    /** Build date */
    date: string;
    /** Kernel version */
    kernel_version?: string;
    /** Full firmware version string */
    firmware_version?: string;
  };
  /** Modules information (key — module name) */
  modules: {
    [key: string]: {
      /** Module version/branch */
      version?: string;
      /** Build number (Jenkins) */
      build?: string;
      /** Commit SHA */
      revision?: string;
      /** Build time (ISO 8601) */
      build_datetime?: string;
      /** Jenkins build URL */
      build_url?: string;
    };
  };
  /** System information */
  system: {
    /** CPU model names */
    cpus: string[];
    /** Total RAM in bytes */
    ram: number;
    /** Current time (unix timestamp) */
    time: number;
    /** System uptime in seconds */
    uptime: number;
    /** Timezone string */
    timezone: string;
    /** Hardware card names */
    cards: string[];
  };
  /** Server alias */
  alias?: string;
};
export type GetInfoApiArg = void;
export type GetInfoBasicApiResponse = /** status 200 OK */ {
  /** Build identity */
  build: {
    /** Firmware version */
    version: string;
    /** Firmware type */
    type: string;
  };
  /** Server alias */
  alias?: string;
};
export type GetInfoBasicApiArg = void;
export type PutInfoAliasApiResponse = /** status 200 OK */ {
  /** Updated server alias */
  alias: string;
};
export type PutInfoAliasApiArg = {
  body: {
    /** new alias */
    alias: string;
  };
};
export type GetIssuesApiResponse = /** status 200 OK */ Issue[];
export type GetIssuesApiArg = void;
export type GetLicenseApiResponse = /** status 200 OK */ LicenseInfo;
export type GetLicenseApiArg = void;
export type PostLicenseApiResponse = unknown;
export type PostLicenseApiArg = {
  body: Blob;
};
export type GetLoadApiResponse = /** status 200 OK */ {
  /** CPU usage percentage */
  cpu: number;
  /** CPU usage details */
  cpuDetails: {
    /** Overall CPU usage percentage */
    usage: number;
    /** Per-core CPU usage */
    cores: {
      /** Core usage percentage */
      usage: number;
    }[];
  };
  /** Memory information */
  mem: {
    /** Total memory in KB */
    total: number;
    /** Free memory in KB */
    free: number;
    /** Available memory in KB */
    available: number;
  };
  /** GPU usage information */
  gpu?: {
    /** GPU engine usage percentages */
    usage: {
      /** Video engine usage */
      video?: number;
      /** Render engine usage */
      render?: number;
      /** Video enhance engine usage */
      videoE?: number;
      /** Blitter engine usage */
      blitter?: number;
    };
    /** GT frequencies */
    gtFrequencies: {
      /** Max GT frequency */
      max: number;
      /** Average GT frequency */
      avg: number;
    };
    /** Whether GPU load is normal */
    normal: boolean;
  };
  /** Swap usage information */
  swap?: {
    /** Swap device list */
    devices: {
      /** Device name */
      name: string;
      /** Total size in KB */
      size: number;
      /** Used size in KB */
      used: number;
      /** Usage percentage */
      usage: number;
    }[];
    /** Swap totals */
    total: {
      /** Total size in KB */
      size: number;
      /** Used size in KB */
      used: number;
      /** Usage percentage */
      usage: number;
    };
  };
  /** Network statistics per interface */
  networkStats?: {
    /** Statistics for one interface */
    $iface: {
      /** TX speed in Mb/s */
      txSpeed: number;
      /** RX speed in Mb/s */
      rxSpeed: number;
    };
  };
  /** Disk I/O statistics per disk */
  disksIO?: {
    /** I/O statistics for one disk */
    $disk: {
      /** I/O utilization percentage */
      ioPercent: number;
    };
  };
  /** CPU temperature readings */
  cpuTemperature?: {
    /** Current temperature */
    value?: number;
    /** High threshold */
    high?: number;
    /** Critical threshold */
    critical?: number;
  };
  /** Disk temperature readings */
  disksTemperature?: {
    /** Temperature value */
    $disk: number;
  };
};
export type GetLoadApiArg = void;
export type PostLoginApiResponse = /** status 200 OK */ {
  /** Authenticated username */
  username: string;
  /** User role */
  role: string;
};
export type PostLoginApiArg = {
  body: {
    /** Username */
    username: string;
    /** Password */
    password: string;
  };
};
export type DeleteModulesByIdApiResponse = unknown;
export type DeleteModulesByIdApiArg = {
  id: string;
};
export type PutModulesByIdApiResponse = unknown;
export type PutModulesByIdApiArg = {
  id: string;
};
export type DeleteModulesByNameUpdateErrorApiResponse = unknown;
export type DeleteModulesByNameUpdateErrorApiArg = {
  name: string;
};
export type GetModulesDiskUsageApiResponse = /** status 200 OK */ DiskUsage;
export type GetModulesDiskUsageApiArg = void;
export type GetModulesUploadByIdStatusApiResponse = /** status 200 OK */ {
  /** Upload progress info */
  info: {
    /** Bytes received */
    received: number;
    /** Total bytes estimated */
    estimated: number;
    /** Whether upload is complete */
    uploadFinished: boolean;
  };
  /** Upload metadata */
  meta: {
    /** Source URI */
    uri?: string;
    /** Whether upload was via POST */
    post: boolean;
  };
  /** Upload operation ID */
  id: string;
  /** Upload status (PROCESSING, RESOLVED, REJECTED, NOT_FOUND) */
  status: string;
  /** Error details (when status is REJECTED) */
  error?: {
    /** Error message */
    message?: string;
    /** Error type */
    type?: string;
  };
  /** Uploaded module images (when status is RESOLVED) */
  value?: {
    /** Module image ID */
    id: string;
    /** Module name */
    name: string;
    /** Module version */
    version: string;
    /** Build identifier */
    build: number;
    /** Source revision */
    revision: string;
    /** Build date */
    buildDate: string;
    /** Docker image tags */
    tags: string[];
    /** Whether module is being updated */
    updating: boolean;
  }[];
};
export type GetModulesUploadByIdStatusApiArg = {
  /** upload id */
  id: string;
};
export type GetModulesApiResponse = /** status 200 OK */ {
  /** List of modules */
  modules: ModuleItem[];
  /** Per-service-name records of failed updates (excludes dismissed) */
  updateErrors: {
    [key: string]: {
      /** Tag the user tried to install */
      attemptedTag: string;
      /** Tag rolled back to */
      restoredTag: string;
      /** Short reason of failure */
      reason: string;
      /** Tail of container logs */
      logs: string;
      /** Unix seconds when rollback happened */
      timestamp: number;
      /** Always false in the response (dismissed entries are filtered out) */
      dismissed: boolean;
    };
  };
  /** True while a `system` update is running and its outcome is not yet known */
  systemUpdateInProgress: boolean;
};
export type GetModulesApiArg = void;
export type PostModulesApiResponse = /** status 200 OK */ {
  /** Module image ID */
  id: string;
  /** Module name */
  name: string;
  /** Module version */
  version: string;
  /** Build identifier */
  build: number;
  /** Source revision */
  revision: string;
  /** Build date */
  buildDate: string;
  /** Docker image tags */
  tags: string[];
  /** Whether module is being updated */
  updating: boolean;
  /** Module components */
  components?: {
    [key: string]: {
      /** Component revision */
      revision?: string;
      /** Component version */
      version?: string;
      /** Component build URL */
      buildUrl?: string;
      /** Component variant */
      variant?: string;
    };
  };
  /** Module dependencies */
  dependencies?: {
    [key: string]: string;
  };
  /** Module conflicts */
  conflicts?: {
    [key: string]: string;
  };
}[];
export type PostModulesApiArg = {
  body: Blob;
};
export type PutModulesUploadByIdInterruptApiResponse = unknown;
export type PutModulesUploadByIdInterruptApiArg = {
  id: string;
};
export type GetModulesUploadByIdJoinApiResponse = /** status 200 OK */ {
  /** Module image ID */
  id: string;
  /** Module name */
  name: string;
  /** Module version */
  version: string;
  /** Build identifier */
  build: number;
  /** Source revision */
  revision: string;
  /** Build date */
  buildDate: string;
  /** Docker image tags */
  tags: string[];
  /** Whether module is being updated */
  updating: boolean;
  /** Module components */
  components?: {
    [key: string]: {
      /** Component revision */
      revision?: string;
      /** Component version */
      version?: string;
      /** Component build URL */
      buildUrl?: string;
      /** Component variant */
      variant?: string;
    };
  };
  /** Module dependencies */
  dependencies?: {
    [key: string]: string;
  };
  /** Module conflicts */
  conflicts?: {
    [key: string]: string;
  };
}[];
export type GetModulesUploadByIdJoinApiArg = {
  /** upload id */
  id: string;
};
export type GetModulesUploadListApiResponse = /** status 200 OK */ {
  /** Upload progress info */
  info: {
    /** Bytes received */
    received: number;
    /** Total bytes estimated */
    estimated: number;
    /** Whether upload is complete */
    uploadFinished: boolean;
  };
  /** Upload metadata */
  meta: {
    /** Source URI */
    uri?: string;
    /** Whether upload was via POST */
    post: boolean;
  };
  /** Upload operation ID */
  id: string;
  /** Upload status (PROCESSING, RESOLVED, REJECTED, NOT_FOUND) */
  status: string;
}[];
export type GetModulesUploadListApiArg = {
  /** if set and equals to 'true' only active uploads are listed */
  active?: string;
};
export type PostModulesLinkApiResponse = /** status 200 OK */ {
  /** Upload operation ID */
  id: string;
};
export type PostModulesLinkApiArg = {
  body: {
    /** uri to download module from */
    link: string;
  };
};
export type PostNetworkAcceptApiResponse = unknown;
export type PostNetworkAcceptApiArg = void;
export type PostNetworkDeclineApiResponse = unknown;
export type PostNetworkDeclineApiArg = void;
export type GetNetworkApiResponse = /** status 200 OK */ {
  /** Map of interface name to interface details */
  ifaces: {
    [key: string]: {
      /** Interface name */
      name: string;
      /** Interface type: "phys", "vlan", "bond", or "unconfigured" */
      type: string;
      actual?: {
        /** Link state (e.g. "UP", "DOWN") */
        state: string;
        /** Link flags (e.g. "BROADCAST", "MULTICAST") */
        flags: string[];
        /** Virtual link type (e.g. "vlan", "bond") */
        vl_type?: string;
        /** Actual addresses */
        addresses: {
          /** Address with prefix (e.g. "10.1.0.114/16") */
          address: string;
          /** Address flags */
          flags?: string[];
          /** Address label. nullable */
          label?: string | null;
          /** Address scope. nullable */
          scope?: string | null;
        }[];
        /** Interface statistics */
        stats?: {
          /** Link speed in Mbps. nullable */
          speed?: number | null;
          /** Carrier detected. nullable */
          carrier?: boolean | null;
        };
        /** MAC address */
        mac?: string;
      } | null;
      config?: {
        /** Configured addresses (CIDR) */
        addresses?: string[];
        /** Bond name if interface is a bond slave. nullable */
        bond?: string | null;
        dhcp?: {
          /** DHCP server address (CIDR) */
          address: string;
          /** DHCP address ranges */
          ranges: {
            /** Range start IP */
            from: string;
            /** Range end IP */
            to: string;
          }[];
          /** DNS server addresses */
          dns_servers: string[];
          /** Gateway address */
          gateway: string;
          /** NTP server addresses */
          ntp_servers?: string[];
          /** Timezone (e.g. "Europe/Moscow") */
          timezone?: string;
        } | null;
        /** DNS server configuration */
        dns?: {
          /** DNS server enabled */
          enabled: boolean;
        };
        /** Static routes */
        routes?: {
          /** Route destination (CIDR) */
          destination: string;
          /** Route gateway */
          gateway?: string;
        }[];
        /** VLAN ID (vlan type only) */
        id?: number;
        /** Parent interfaces (vlan type only) */
        ifaces?: string[];
        /** Bond mode (bond type only) */
        mode?: 'balance-rr' | 'active-backup' | 'balance-xor' | 'broadcast' | '802.3ad' | 'balance-tlb' | 'balance-alb';
        /** Transmit hash policy (bond type only) */
        transmitHashPolicy?: 'layer2' | 'layer3+4' | 'layer2+3' | 'encap2+3' | 'encap3+4';
        /** MII monitor interval in seconds (bond type only) */
        miiMonitorSec?: number;
        /** LACP transmit rate (bond type only) */
        lacpTransmitRate?: 'slow' | 'fast';
      } | null;
    };
  };
  /** Whether network is in trial mode */
  inTrial: boolean;
  /** Actual routing table */
  actualRoutes: {
    /** Route destination (CIDR) */
    destination: string;
    /** Route gateway */
    gateway?: string;
    /** Route interface */
    iface?: string;
    /** Route protocol */
    proto?: string;
  }[];
  /** Validation errors */
  errors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      [key: string]: unknown;
    }[];
  }[];
};
export type GetNetworkApiArg = void;
export type PutNetworkApiResponse = /** status 200 OK */ {
  /** Address intersection warnings from incoming settings */
  newErrors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      /** Intersecting addresses (CIDR conflict) */
      intersection?: string[];
    }[];
  }[];
  /** Map of interface name to interface details */
  ifaces: {
    [key: string]: {
      /** Interface name */
      name: string;
      /** Interface type: "phys", "vlan", "bond", or "unconfigured" */
      type: string;
      actual?: {
        /** Link state (e.g. "UP", "DOWN") */
        state: string;
        /** Link flags (e.g. "BROADCAST", "MULTICAST") */
        flags: string[];
        /** Virtual link type (e.g. "vlan", "bond") */
        vl_type?: string;
        /** Actual addresses */
        addresses: {
          /** Address with prefix (e.g. "10.1.0.114/16") */
          address: string;
          /** Address flags */
          flags?: string[];
          /** Address label. nullable */
          label?: string | null;
          /** Address scope. nullable */
          scope?: string | null;
        }[];
        /** Interface statistics */
        stats?: {
          /** Link speed in Mbps. nullable */
          speed?: number | null;
          /** Carrier detected. nullable */
          carrier?: boolean | null;
        };
        /** MAC address */
        mac?: string;
      } | null;
      config?: {
        /** Configured addresses (CIDR) */
        addresses?: string[];
        /** Bond name if interface is a bond slave. nullable */
        bond?: string | null;
        dhcp?: {
          /** DHCP server address (CIDR) */
          address: string;
          /** DHCP address ranges */
          ranges: {
            /** Range start IP */
            from: string;
            /** Range end IP */
            to: string;
          }[];
          /** DNS server addresses */
          dns_servers: string[];
          /** Gateway address */
          gateway: string;
          /** NTP server addresses */
          ntp_servers?: string[];
          /** Timezone (e.g. "Europe/Moscow") */
          timezone?: string;
        } | null;
        /** DNS server configuration */
        dns?: {
          /** DNS server enabled */
          enabled: boolean;
        };
        /** Static routes */
        routes?: {
          /** Route destination (CIDR) */
          destination: string;
          /** Route gateway */
          gateway?: string;
        }[];
        /** VLAN ID (vlan type only) */
        id?: number;
        /** Parent interfaces (vlan type only) */
        ifaces?: string[];
        /** Bond mode (bond type only) */
        mode?: 'balance-rr' | 'active-backup' | 'balance-xor' | 'broadcast' | '802.3ad' | 'balance-tlb' | 'balance-alb';
        /** Transmit hash policy (bond type only) */
        transmitHashPolicy?: 'layer2' | 'layer3+4' | 'layer2+3' | 'encap2+3' | 'encap3+4';
        /** MII monitor interval in seconds (bond type only) */
        miiMonitorSec?: number;
        /** LACP transmit rate (bond type only) */
        lacpTransmitRate?: 'slow' | 'fast';
      } | null;
    };
  };
  /** Whether network is in trial mode */
  inTrial: boolean;
  /** Actual routing table */
  actualRoutes: {
    /** Route destination (CIDR) */
    destination: string;
    /** Route gateway */
    gateway?: string;
    /** Route interface */
    iface?: string;
    /** Route protocol */
    proto?: string;
  }[];
  /** Validation errors */
  errors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      [key: string]: unknown;
    }[];
  }[];
};
export type PutNetworkApiArg = {
  body: {
    ifaces?: {
      [key: string]: {
        /** interface name */
        name?: string;
        /** interface type (phys, vlan, bond) */
        type?: string;
        config?: {
          /** if iface is in bond, this param must store it's name. nullable */
          bond?: string | null;
          addresses?: string[];
          dhcp?: {
            /** DHCP address CIDR */
            address: string;
            ranges: {
              /** start of DHCP-server IP range */
              from: string;
              /** end of DHCP-server IP range */
              to: string;
            }[];
            dns_servers: string[];
            /** Gateway address */
            gateway: string;
            ntp_servers?: string[];
            /** DHCP timezone */
            timezone?: string;
          } | null;
          dns?: {
            /** enable dns-server on interface */
            enabled: boolean;
          };
          routes?: {
            /** route destination (CIDR) */
            destination: string;
            /** route gateway */
            gateway?: string;
          }[];
          /** VLAN ID (vlan type only) */
          id?: number;
          ifaces?: string[];
          /** Bond mode (bond type only) */
          mode?: string;
          /** Transmit hash policy (bond type only) */
          transmitHashPolicy?: string;
          /** MII monitor interval in seconds (bond type only) */
          miiMonitorSec?: number;
          /** LACP transmit rate (bond type only) */
          lacpTransmitRate?: string;
        };
      } | null;
    };
  };
};
export type PutNetworkTryByDelayApiResponse = /** status 200 OK */ {
  /** Address intersection warnings from incoming settings */
  newErrors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      /** Intersecting addresses (CIDR conflict) */
      intersection?: string[];
    }[];
  }[];
  /** Map of interface name to interface details */
  ifaces: {
    [key: string]: {
      /** Interface name */
      name: string;
      /** Interface type: "phys", "vlan", "bond", or "unconfigured" */
      type: string;
      actual?: {
        /** Link state (e.g. "UP", "DOWN") */
        state: string;
        /** Link flags (e.g. "BROADCAST", "MULTICAST") */
        flags: string[];
        /** Virtual link type (e.g. "vlan", "bond") */
        vl_type?: string;
        /** Actual addresses */
        addresses: {
          /** Address with prefix (e.g. "10.1.0.114/16") */
          address: string;
          /** Address flags */
          flags?: string[];
          /** Address label. nullable */
          label?: string | null;
          /** Address scope. nullable */
          scope?: string | null;
        }[];
        /** Interface statistics */
        stats?: {
          /** Link speed in Mbps. nullable */
          speed?: number | null;
          /** Carrier detected. nullable */
          carrier?: boolean | null;
        };
        /** MAC address */
        mac?: string;
      } | null;
      config?: {
        /** Configured addresses (CIDR) */
        addresses?: string[];
        /** Bond name if interface is a bond slave. nullable */
        bond?: string | null;
        dhcp?: {
          /** DHCP server address (CIDR) */
          address: string;
          /** DHCP address ranges */
          ranges: {
            /** Range start IP */
            from: string;
            /** Range end IP */
            to: string;
          }[];
          /** DNS server addresses */
          dns_servers: string[];
          /** Gateway address */
          gateway: string;
          /** NTP server addresses */
          ntp_servers?: string[];
          /** Timezone (e.g. "Europe/Moscow") */
          timezone?: string;
        } | null;
        /** DNS server configuration */
        dns?: {
          /** DNS server enabled */
          enabled: boolean;
        };
        /** Static routes */
        routes?: {
          /** Route destination (CIDR) */
          destination: string;
          /** Route gateway */
          gateway?: string;
        }[];
        /** VLAN ID (vlan type only) */
        id?: number;
        /** Parent interfaces (vlan type only) */
        ifaces?: string[];
        /** Bond mode (bond type only) */
        mode?: 'balance-rr' | 'active-backup' | 'balance-xor' | 'broadcast' | '802.3ad' | 'balance-tlb' | 'balance-alb';
        /** Transmit hash policy (bond type only) */
        transmitHashPolicy?: 'layer2' | 'layer3+4' | 'layer2+3' | 'encap2+3' | 'encap3+4';
        /** MII monitor interval in seconds (bond type only) */
        miiMonitorSec?: number;
        /** LACP transmit rate (bond type only) */
        lacpTransmitRate?: 'slow' | 'fast';
      } | null;
    };
  };
  /** Whether network is in trial mode */
  inTrial: boolean;
  /** Actual routing table */
  actualRoutes: {
    /** Route destination (CIDR) */
    destination: string;
    /** Route gateway */
    gateway?: string;
    /** Route interface */
    iface?: string;
    /** Route protocol */
    proto?: string;
  }[];
  /** Validation errors */
  errors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      [key: string]: unknown;
    }[];
  }[];
};
export type PutNetworkTryByDelayApiArg = {
  delay: string;
  body: {
    ifaces?: {
      [key: string]: {
        /** interface name */
        name?: string;
        /** interface type (phys, vlan, bond) */
        type?: string;
        config?: {
          /** if iface is in bond, this param must store it's name. nullable */
          bond?: string | null;
          addresses?: string[];
          dhcp?: {
            /** DHCP address CIDR */
            address: string;
            ranges: {
              /** start of DHCP-server IP range */
              from: string;
              /** end of DHCP-server IP range */
              to: string;
            }[];
            dns_servers: string[];
            /** Gateway address */
            gateway: string;
            ntp_servers?: string[];
            /** DHCP timezone */
            timezone?: string;
          } | null;
          dns?: {
            /** enable dns-server on interface */
            enabled: boolean;
          };
          routes?: {
            /** route destination (CIDR) */
            destination: string;
            /** route gateway */
            gateway?: string;
          }[];
          /** VLAN ID (vlan type only) */
          id?: number;
          ifaces?: string[];
          /** Bond mode (bond type only) */
          mode?: string;
          /** Transmit hash policy (bond type only) */
          transmitHashPolicy?: string;
          /** MII monitor interval in seconds (bond type only) */
          miiMonitorSec?: number;
          /** LACP transmit rate (bond type only) */
          lacpTransmitRate?: string;
        };
      } | null;
    };
  };
};
export type PutNetworkTryApiResponse = /** status 200 OK */ {
  /** Address intersection warnings from incoming settings */
  newErrors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      /** Intersecting addresses (CIDR conflict) */
      intersection?: string[];
    }[];
  }[];
  /** Map of interface name to interface details */
  ifaces: {
    [key: string]: {
      /** Interface name */
      name: string;
      /** Interface type: "phys", "vlan", "bond", or "unconfigured" */
      type: string;
      actual?: {
        /** Link state (e.g. "UP", "DOWN") */
        state: string;
        /** Link flags (e.g. "BROADCAST", "MULTICAST") */
        flags: string[];
        /** Virtual link type (e.g. "vlan", "bond") */
        vl_type?: string;
        /** Actual addresses */
        addresses: {
          /** Address with prefix (e.g. "10.1.0.114/16") */
          address: string;
          /** Address flags */
          flags?: string[];
          /** Address label. nullable */
          label?: string | null;
          /** Address scope. nullable */
          scope?: string | null;
        }[];
        /** Interface statistics */
        stats?: {
          /** Link speed in Mbps. nullable */
          speed?: number | null;
          /** Carrier detected. nullable */
          carrier?: boolean | null;
        };
        /** MAC address */
        mac?: string;
      } | null;
      config?: {
        /** Configured addresses (CIDR) */
        addresses?: string[];
        /** Bond name if interface is a bond slave. nullable */
        bond?: string | null;
        dhcp?: {
          /** DHCP server address (CIDR) */
          address: string;
          /** DHCP address ranges */
          ranges: {
            /** Range start IP */
            from: string;
            /** Range end IP */
            to: string;
          }[];
          /** DNS server addresses */
          dns_servers: string[];
          /** Gateway address */
          gateway: string;
          /** NTP server addresses */
          ntp_servers?: string[];
          /** Timezone (e.g. "Europe/Moscow") */
          timezone?: string;
        } | null;
        /** DNS server configuration */
        dns?: {
          /** DNS server enabled */
          enabled: boolean;
        };
        /** Static routes */
        routes?: {
          /** Route destination (CIDR) */
          destination: string;
          /** Route gateway */
          gateway?: string;
        }[];
        /** VLAN ID (vlan type only) */
        id?: number;
        /** Parent interfaces (vlan type only) */
        ifaces?: string[];
        /** Bond mode (bond type only) */
        mode?: 'balance-rr' | 'active-backup' | 'balance-xor' | 'broadcast' | '802.3ad' | 'balance-tlb' | 'balance-alb';
        /** Transmit hash policy (bond type only) */
        transmitHashPolicy?: 'layer2' | 'layer3+4' | 'layer2+3' | 'encap2+3' | 'encap3+4';
        /** MII monitor interval in seconds (bond type only) */
        miiMonitorSec?: number;
        /** LACP transmit rate (bond type only) */
        lacpTransmitRate?: 'slow' | 'fast';
      } | null;
    };
  };
  /** Whether network is in trial mode */
  inTrial: boolean;
  /** Actual routing table */
  actualRoutes: {
    /** Route destination (CIDR) */
    destination: string;
    /** Route gateway */
    gateway?: string;
    /** Route interface */
    iface?: string;
    /** Route protocol */
    proto?: string;
  }[];
  /** Validation errors */
  errors: {
    /** Error type identifier */
    type: string;
    /** Human-readable error message */
    message: string;
    /** Error context */
    extra?: {
      [key: string]: unknown;
    }[];
  }[];
};
export type PutNetworkTryApiArg = {
  body: {
    ifaces?: {
      [key: string]: {
        /** interface name */
        name?: string;
        /** interface type (phys, vlan, bond) */
        type?: string;
        config?: {
          /** if iface is in bond, this param must store it's name. nullable */
          bond?: string | null;
          addresses?: string[];
          dhcp?: {
            /** DHCP address CIDR */
            address: string;
            ranges: {
              /** start of DHCP-server IP range */
              from: string;
              /** end of DHCP-server IP range */
              to: string;
            }[];
            dns_servers: string[];
            /** Gateway address */
            gateway: string;
            ntp_servers?: string[];
            /** DHCP timezone */
            timezone?: string;
          } | null;
          dns?: {
            /** enable dns-server on interface */
            enabled: boolean;
          };
          routes?: {
            /** route destination (CIDR) */
            destination: string;
            /** route gateway */
            gateway?: string;
          }[];
          /** VLAN ID (vlan type only) */
          id?: number;
          ifaces?: string[];
          /** Bond mode (bond type only) */
          mode?: string;
          /** Transmit hash policy (bond type only) */
          transmitHashPolicy?: string;
          /** MII monitor interval in seconds (bond type only) */
          miiMonitorSec?: number;
          /** LACP transmit rate (bond type only) */
          lacpTransmitRate?: string;
        };
      } | null;
    };
  };
};
export type GetPortAccessApiResponse = /** status 200 OK */ {
  /** Per-interface restrictions (key = interface name) */
  config: {
    [key: string]: {
      /** Allow web UI access */
      webUi?: boolean;
      /** Allow SSH access */
      ssh?: boolean;
    };
  };
  /** Interface names eligible for port access restrictions */
  ifaces: string[];
};
export type GetPortAccessApiArg = void;
export type PutPortAccessApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** Allow web UI access */
    webUi?: boolean;
    /** Allow SSH access */
    ssh?: boolean;
  };
};
export type PutPortAccessApiArg = {
  body: {
    /** Allow blocking current interface */
    force: boolean;
    [key: string]:
      | {
          /** Allow web UI access */
          webUi?: boolean;
          /** Allow SSH access */
          ssh?: boolean;
        }
      | boolean;
  };
};
export type PostPoweroffApiResponse = /** status 200 OK */ boolean;
export type PostPoweroffApiArg = void;
export type PostRebootApiResponse = /** status 200 OK */ boolean;
export type PostRebootApiArg = void;
export type PostRoleGrantsByRoleApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** List of ancestor roles the role extends */
    $extend: string[];
    /** Modules the role grants admin UI access to, keyed by module name */
    moduleAccess: {
      [key: string]: unknown;
    };
    [key: string]:
      | (
          | {
              /** Whether the role has read access to the resource */
              read?: boolean;
              /** Whether the role has write access to the resource */
              write?: boolean;
            }
          | string[]
          | {
              [key: string]: unknown;
            }
        )
      | string[]
      | {
          [key: string]: unknown;
        };
  };
};
export type PostRoleGrantsByRoleApiArg = {
  role: string;
};
export type DeleteRoleGrantsByRoleApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** List of ancestor roles the role extends */
    $extend: string[];
    /** Modules the role grants admin UI access to, keyed by module name */
    moduleAccess: {
      [key: string]: unknown;
    };
    [key: string]:
      | (
          | {
              /** Whether the role has read access to the resource */
              read?: boolean;
              /** Whether the role has write access to the resource */
              write?: boolean;
            }
          | string[]
          | {
              [key: string]: unknown;
            }
        )
      | string[]
      | {
          [key: string]: unknown;
        };
  };
};
export type DeleteRoleGrantsByRoleApiArg = {
  role: string;
};
export type PutRoleGrantsByRoleApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** List of ancestor roles the role extends */
    $extend: string[];
    /** Modules the role grants admin UI access to, keyed by module name */
    moduleAccess: {
      [key: string]: unknown;
    };
    [key: string]:
      | (
          | {
              /** Whether the role has read access to the resource */
              read?: boolean;
              /** Whether the role has write access to the resource */
              write?: boolean;
            }
          | string[]
          | {
              [key: string]: unknown;
            }
        )
      | string[]
      | {
          [key: string]: unknown;
        };
  };
};
export type PutRoleGrantsByRoleApiArg = {
  role: string;
  body: {
    ancestors: string[];
    grants: {
      [key: string]: {
        /** Whether the role has read access to the resource */
        read?: boolean;
        /** Whether the role has write access to the resource */
        write?: boolean;
      };
    };
    modules: string[];
  };
};
export type GetRoleAvailableModulesApiResponse = /** status 200 OK */ {
  /** Installed module names with admin UI */
  modules: string[];
};
export type GetRoleAvailableModulesApiArg = void;
export type GetRoleApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** List of ancestor roles the role extends */
    $extend: string[];
    /** Modules the role grants admin UI access to, keyed by module name */
    moduleAccess: {
      [key: string]: unknown;
    };
    [key: string]:
      | (
          | {
              /** Whether the role has read access to the resource */
              read?: boolean;
              /** Whether the role has write access to the resource */
              write?: boolean;
            }
          | string[]
          | {
              [key: string]: unknown;
            }
        )
      | string[]
      | {
          [key: string]: unknown;
        };
  };
};
export type GetRoleApiArg = void;
export type DeleteServicesByIdApiResponse = /** status 200 OK */ {
  /** List of services */
  services: {
    /** Service ID */
    id: string;
    /** Module image reference */
    module: string;
    /** Whether the service is running */
    running: boolean;
    /** Service status text */
    status: string;
    /** Service name */
    name: string;
    /** Service state */
    state: 'created' | 'running' | 'exited' | 'restarting' | 'removing' | 'paused' | 'dead' | 'unknown';
  }[];
};
export type DeleteServicesByIdApiArg = {
  id: string;
};
export type GetServicesApiResponse = /** status 200 OK */ {
  /** List of services */
  services: ServiceItem[];
};
export type GetServicesApiArg = void;
export type GetServicesBasicApiResponse = /** status 200 OK */ {
  services: {
    /** Service name */
    name: string;
    /** Service state */
    state: string;
    /** Whether the service is running */
    running: boolean;
    /** Code identity of the deployed service, `<version>.<build>` from docker labels (e.g. `master.3923`), revision fallback; absent without version labels */
    build?: string;
    /** Unified-admin federation descriptor (from `tv.netup.service.unified-admin` label), present only for modules that opt in */
    unifiedAdmin?: {
      /** Contract version the module declares support for */
      contract: number;
      /** Module id (federation namespace) */
      id: string;
      /** remoteEntry.js filename, relative to the module web root */
      remoteEntry: string;
      /** mf-manifest.json filename, relative to the module web root */
      mfManifest: string;
    };
  }[];
  /** Service operations this server is running right now, so a client can tell a container being recreated from a service that went away; absent on servers that do not report them */
  operations?: {
    /** Service name the operation applies to */
    name: string;
    /** Operation kind */
    kind: 'updating' | 'removing';
  }[];
};
export type GetServicesBasicApiArg = void;
export type PutServicesByIdByCommandApiResponse = /** status 200 OK */ {
  /** List of services */
  services: {
    /** Service ID */
    id: string;
    /** Module image reference */
    module: string;
    /** Whether the service is running */
    running: boolean;
    /** Service status text */
    status: string;
    /** Service name */
    name: string;
    /** Service state */
    state: 'created' | 'running' | 'exited' | 'restarting' | 'removing' | 'paused' | 'dead' | 'unknown';
  }[];
};
export type PutServicesByIdByCommandApiArg = {
  id: string;
  command: string;
};
export type PostTimeNtpByHostApiResponse = /** status 200 OK */ boolean;
export type PostTimeNtpByHostApiArg = {
  host: string;
};
export type DeleteTimeNtpByHostApiResponse = /** status 200 OK */ boolean;
export type DeleteTimeNtpByHostApiArg = {
  host: string;
};
export type GetTimeApiResponse = /** status 200 OK */ {
  /** Date components */
  date: {
    /** Year */
    year: number;
    /** Month (0-11) */
    month: number;
    /** Day of month (1-31) */
    date: number;
    /** Hours (0-23) */
    hours: number;
    /** Minutes (0-59) */
    minutes: number;
    /** Seconds (0-59) */
    seconds: number;
  };
  /** Timezone info */
  timezone: {
    /** Timezone name */
    name: string;
    /** UTC offset in minutes */
    offset: number;
  };
  /** List of NTP server hosts */
  ntpServers: string[];
  /** Whether NTP client is active */
  isNtpActive: boolean;
  /** Whether NTP server is active */
  isNtpServerActive: boolean;
};
export type GetTimeApiArg = void;
export type GetTimeTimezoneListApiResponse = /** status 200 OK */ {
  [key: string]: string;
};
export type GetTimeTimezoneListApiArg = void;
export type PutTimeDatetimeApiResponse = /** status 200 OK */ boolean;
export type PutTimeDatetimeApiArg = {
  body: {
    /** Year */
    year: number;
    /** Month */
    month: number;
    /** Date */
    date: number;
    /** Hours */
    hours: number;
    /** Minutes */
    minutes: number;
    /** Seconds */
    seconds: number;
  };
};
export type PutTimeTimezoneApiResponse = /** status 200 OK */ boolean;
export type PutTimeTimezoneApiArg = {
  body: {
    /** timezone (example: "Europe/Moscow") */
    timezone: string;
  };
};
export type PutTimeNtpServerByStateApiResponse = /** status 200 OK */ boolean;
export type PutTimeNtpServerByStateApiArg = {
  state: string;
};
export type PutTimeNtpByStateApiResponse = /** status 200 OK */ boolean;
export type PutTimeNtpByStateApiArg = {
  state: string;
};
export type PostTokensApiResponse = /** status 200 OK */ {
  /** Token id */
  id: string;
  /** Owner username */
  owner: string;
  /** Roles carried by the token */
  roles: string[];
  /** Human-readable label */
  label: string;
  /** Creation time (ISO 8601) */
  createdAt: string;
  /** Expiry time (ISO 8601), nullable — null if no expiry */
  expiresAt?: string | null;
  /** Token secret (shown once) */
  secret: string;
};
export type PostTokensApiArg = {
  body: {
    /** Human-readable label */
    label: string;
    roles: string[];
    /** Owner username (defaults to caller; other owners require tokens write access) */
    owner?: string;
    /** Expiry time (ISO 8601); omit for no expiry */
    expiresAt?: string;
  };
};
export type GetTokensApiResponse = /** status 200 OK */ {
  /** Token id */
  id: string;
  /** Owner username */
  owner: string;
  /** Roles carried by the token */
  roles: string[];
  /** Human-readable label */
  label: string;
  /** Creation time (ISO 8601) */
  createdAt: string;
  /** Expiry time (ISO 8601), nullable — null if no expiry */
  expiresAt?: string | null;
}[];
export type GetTokensApiArg = void;
export type DeleteTokensByIdApiResponse = /** status 200 OK */ boolean;
export type DeleteTokensByIdApiArg = {
  id: string;
};
export type PutTokensByIdApiResponse = /** status 200 OK */ {
  /** Token id */
  id: string;
  /** Owner username */
  owner: string;
  /** Roles carried by the token */
  roles: string[];
  /** Human-readable label */
  label: string;
  /** Creation time (ISO 8601) */
  createdAt: string;
  /** Expiry time (ISO 8601), nullable — null if no expiry */
  expiresAt?: string | null;
};
export type PutTokensByIdApiArg = {
  id: string;
  body: {
    /** Human-readable label */
    label: string;
    roles: string[];
    /** Expiry time (ISO 8601), nullable — null or empty clears the expiry */
    expiresAt?: string | null;
  };
};
export type PostUploadProbeLinkApiResponse = /** status 200 OK */ {
  /** Detected artifact family */
  type: 'firmware' | 'modules' | 'backup' | 'license' | 'unknown';
};
export type PostUploadProbeLinkApiArg = {
  body: {
    /** Remote URL to probe */
    link: string;
  };
};
export type PostUserApiResponse = /** status 200 OK */ {
  /** Username */
  username: string;
  /** List of roles */
  roles: string[];
  /** Per-user module grants (independent of roles) */
  modules: string[];
  /** Per-user resource grants (independent of roles) */
  grants: {
    [key: string]: {
      /** Whether the user has read access to the resource */
      read?: boolean;
      /** Whether the user has write access to the resource */
      write?: boolean;
    };
  };
}[];
export type PostUserApiArg = {
  body: {
    /** Username */
    username: string;
    /** Password */
    password: string;
    roles: string[];
  };
};
export type DeleteUserApiResponse = /** status 200 OK */ {
  /** Username */
  username: string;
  /** List of roles */
  roles: string[];
  /** Per-user module grants (independent of roles) */
  modules: string[];
  /** Per-user resource grants (independent of roles) */
  grants: {
    [key: string]: {
      /** Whether the user has read access to the resource */
      read?: boolean;
      /** Whether the user has write access to the resource */
      write?: boolean;
    };
  };
}[];
export type DeleteUserApiArg = {
  body: {
    /** Username */
    username: string;
  };
};
export type GetUserApiResponse = /** status 200 OK */ {
  /** Effective permissions (included when caller has roles read access) */
  permissions?: {
    /** Modules the user may open, keyed by module name */
    moduleAccess: {
      [key: string]: unknown;
    };
    [key: string]:
      | (
          | {
              /** Whether the user has read access to the resource */
              read?: boolean;
              /** Whether the user has write access to the resource */
              write?: boolean;
            }
          | {
              [key: string]: unknown;
            }
        )
      | {
          [key: string]: unknown;
        };
  };
  /** Username */
  username: string;
  /** List of roles */
  roles: string[];
  /** Per-user module grants (independent of roles) */
  modules: string[];
  /** Per-user resource grants (independent of roles) */
  grants: {
    [key: string]: {
      /** Whether the user has read access to the resource */
      read?: boolean;
      /** Whether the user has write access to the resource */
      write?: boolean;
    };
  };
}[];
export type GetUserApiArg = void;
export type PutUserApiResponse = /** status 200 OK */ {
  /** Username */
  username: string;
  /** List of roles */
  roles: string[];
  /** Per-user module grants (independent of roles) */
  modules: string[];
  /** Per-user resource grants (independent of roles) */
  grants: {
    [key: string]: {
      /** Whether the user has read access to the resource */
      read?: boolean;
      /** Whether the user has write access to the resource */
      write?: boolean;
    };
  };
}[];
export type PutUserApiArg = {
  body: {
    /** Username */
    username: string;
    /** Password */
    password?: string;
    roles?: string[];
  };
};
export type PutUserByUsernamePermissionsApiResponse = /** status 200 OK */ {
  /** Username */
  username: string;
  /** List of roles */
  roles: string[];
  /** Per-user module grants (independent of roles) */
  modules: string[];
  /** Per-user resource grants (independent of roles) */
  grants: {
    [key: string]: {
      /** Whether the user has read access to the resource */
      read?: boolean;
      /** Whether the user has write access to the resource */
      write?: boolean;
    };
  };
}[];
export type PutUserByUsernamePermissionsApiArg = {
  username: string;
  body: {
    grants: {
      [key: string]: {
        /** Whether the user has read access to the resource */
        read?: boolean;
        /** Whether the user has write access to the resource */
        write?: boolean;
      };
    };
    modules: string[];
  };
};
export type GetVtunApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** Is tunnel enabled */
    enabled?: boolean;
    /** Remote host name */
    host?: string;
    /** Remote port number */
    port?: number;
    /** Name of virtual network device */
    device?: string;
    /** Timeout in seconds */
    timeout?: number;
    /** Persist mode */
    persist?: string;
    /** Name of vtun session */
    session?: string;
    /** Password */
    password?: string;
    /** Local IP address */
    local_ip?: string;
    /** Remote IP address */
    remote_ip?: string;
  };
};
export type GetVtunApiArg = void;
export type PutVtunApiResponse = /** status 200 OK */ {
  [key: string]: {
    /** Is tunnel enabled */
    enabled?: boolean;
    /** Remote host name */
    host?: string;
    /** Remote port number */
    port?: number;
    /** Name of virtual network device */
    device?: string;
    /** Timeout in seconds */
    timeout?: number;
    /** Persist mode */
    persist?: string;
    /** Name of vtun session */
    session?: string;
    /** Password */
    password?: string;
    /** Local IP address */
    local_ip?: string;
    /** Remote IP address */
    remote_ip?: string;
  };
};
export type PutVtunApiArg = {
  body: {
    [key: string]: {
      /** Is tunnel enabled */
      enabled?: boolean;
      /** Remote host name */
      host?: string;
      /** Remote port number */
      port?: number;
      /** Name of virtual network device */
      device?: string;
      /** Timeout (seconds) */
      timeout?: number;
      persist?: string;
      /** Name of vtun session */
      session?: string;
      /** Password */
      password?: string;
      /** Remote ip */
      remote_ip?: string;
      /** Local ip */
      local_ip?: string;
    } | null;
  };
};
export type BackupItem = {
  /** Backup filename */
  filename: string;
  /** File statistics (absent when corrupted) */
  stat?: {
    /** File creation time (ISO 8601) */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the backup was created manually */
  isManual: boolean;
  /** Whether the backup is corrupted */
  corrupted?: boolean;
  /** Error message (present when corrupted) */
  error?: string;
  /** Download links for the backup */
  links: string[];
};
export type FirmwareItem = {
  /** Firmware filename */
  filename: string;
  /** File statistics (absent for corrupted firmware) */
  stat?: {
    /** Creation time */
    ctime: string;
    /** File size in bytes */
    size: number;
  };
  /** Whether the firmware is corrupted */
  corrupted: boolean;
  /** Error message (set only when corrupted) */
  error?: string;
  /** Firmware information (parsed from firmware archive's info file; absent for corrupted firmware; all fields are optional and best-effort) */
  info?: {
    /** System sources revision: "<sha> <branch> <build_url>" */
    firmware_revision?: string;
    /** Full firmware version (e.g. "trunk.71") */
    firmware_version?: string;
    /** Kernel revision: "<sha> <branch> <build_url>" */
    firmware_kernel_revision?: string;
    /** lcdproc revision: "<sha> <branch> <build_url>" */
    firmware_lcdproc_revision?: string;
    /** Squashfs MD5 checksum */
    md5sum?: string;
    /** Kernel image MD5 checksum */
    kernelmd5?: string;
    /** initrd image MD5 checksum */
    initrdmd5?: string;
    /** Firmware version (e.g. "trunk.71") */
    version?: string;
    /** Firmware type (e.g. "iptv") */
    type?: string;
    /** Source revision (build number) */
    revision?: string;
    /** Build date (ISO 8601) */
    date?: string;
    /** Kernel version (e.g. "4.4.129") */
    kernel_version?: string;
  };
  /** Modules information (absent for corrupted firmware; key — module name) */
  modules?: {
    [key: string]: {
      /** Module version/branch */
      version?: string;
      /** Build number (Jenkins) */
      build?: string;
      /** Commit SHA */
      revision?: string;
      /** Build time (ISO 8601) */
      build_datetime?: string;
      /** Jenkins build URL */
      build_url?: string;
    };
  };
};
export type Issue = {
  /** Issue type */
  message: string;
  /** Extra data about issue */
  extra: {
    /** Current date as ISODate string */
    now: string;
    /** First valid date of license or component as ISODate string */
    notBefore: string;
    /** Last valid date of license or component as ISODate string */
    notAfter: string;
    /** Last backup creation time as ISODate string */
    last: string;
    /** Title of license component */
    title: string;
    /** Name of the affected object: mountpoint or module */
    name: string;
    /** The `[emerg]` line of the failed `nginx -t`, or its last line */
    reason: string;
    /** Tail of the failed `nginx -t` output */
    error: string;
    /** Time the configuration was rejected as ISODate string */
    since: string;
    /** Container state */
    state: string;
    /** Times docker has restarted the container; reported for `restarting`, absent for `dead` */
    restartCount?: number;
  };
  /** Time difference in milliseconds (client-side, for TIME_DIFFERS_TOO_MUCH) */
  delta?: number;
};
export type LicenseComponentInfo = {
  /** Component subject */
  subject: string;
  /** Component serial number */
  serial: number;
  /** Component validity period */
  validity: {
    /** Valid from date */
    notBefore: string;
    /** Valid until date */
    notAfter: string;
  };
  /** Component title */
  title: string;
  /** Whether component is revoked */
  revoked: boolean;
  /** Whether component is signed */
  signed: boolean;
  /** Component limits */
  limits: {
    /** Limit name */
    name: string;
    /** Limit value */
    value: string;
  }[];
  /** Machine-readable system type key */
  system: string;
  /** Machine-readable license options as parsed from the keystore */
  options: {
    [key: string]: unknown;
  };
  /** IPTVSystem OID suffix of an unrecognized system type */
  unknownOid?: number;
};
export type LicenseInfo = {
  /** License information */
  information?: {
    /** Serial number */
    serial: number;
    /** License validity period */
    validity: {
      /** Valid from date */
      notBefore: string;
      /** Valid until date */
      notAfter: string;
    };
    /** License subject */
    subject: string;
    /** Whether license is revoked */
    revoked: boolean;
    /** Whether license is signed */
    signed: boolean;
  };
  /** License components */
  components?: LicenseComponentInfo[];
};
export type DiskUsage = {
  /** Docker disk usage data */
  usage: {
    /** Usage totals */
    total: {
      /** Image usage stats */
      images: {
        /** Total images count */
        total: number;
        /** Active images count */
        active: number;
        /** Total size in bytes */
        size: number;
        /** Reclaimable size in bytes */
        reclaimable: number;
      };
    };
    /** Individual image details */
    images: {
      /** Image ID */
      id: string;
      /** Repository name */
      repository: string;
      /** Image tag */
      tag: string;
      /** Image size in bytes */
      size: number;
      /** Shared size in bytes */
      sharedSize: number;
      /** Unique size in bytes */
      uniqueSize: number;
      /** Containers using this image */
      containers: number;
    }[];
  };
  /** Last update timestamp in milliseconds */
  lastUpdate: number;
  /** Whether update is in progress */
  updating: boolean;
};
export type ModuleItem = {
  /** Module image ID (sha256 hash) */
  id: string;
  /** Module name */
  name: string;
  /** Module version */
  version: string;
  /** Build identifier */
  build: number;
  /** Source revision */
  revision: string;
  /** Build date */
  buildDate: string;
  /** Docker image tags */
  tags: string[];
  /** Whether module is being updated */
  updating: boolean;
  /** Module components */
  components?: {
    [key: string]: {
      /** Component revision */
      revision?: string;
      /** Component version */
      version?: string;
      /** Component build URL */
      buildUrl?: string;
      /** Component variant */
      variant?: string;
    };
  };
  /** Module dependencies (false if none) */
  dependencies?: {
    [key: string]: string;
  };
  /** Module conflicts (false if none) */
  conflicts?: {
    [key: string]: string;
  };
};
export type ServiceItem = {
  /** Service ID */
  id: string;
  /** Module image reference */
  module: string;
  /** Whether the service is running */
  running: boolean;
  /** Service status text */
  status: string;
  /** Service name */
  name: string;
  /** Service state */
  state: 'created' | 'running' | 'exited' | 'restarting' | 'removing' | 'paused' | 'dead' | 'unknown';
  /** Times docker has restarted the container; reported for containers seen restarting, so a crash loop can be told from a restart on request */
  restartCount?: number;
};
export const {
  usePutProfileMutation,
  useGetProfileQuery,
  useLazyGetProfileQuery,
  usePostLogoutMutation,
  usePostBackupMutation,
  useGetBackupQuery,
  useLazyGetBackupQuery,
  usePostBackupByNameTokenMutation,
  useDeleteBackupByNameMutation,
  usePutBackupByNameMutation,
  usePostBackupByNameMutation,
  useGetBackupByNameDownloadQuery,
  useLazyGetBackupByNameDownloadQuery,
  useGetBackupUploadByIdStatusQuery,
  useLazyGetBackupUploadByIdStatusQuery,
  usePutBackupUploadByIdInterruptMutation,
  useGetBackupUploadByIdJoinQuery,
  useLazyGetBackupUploadByIdJoinQuery,
  useGetBackupUploadListQuery,
  useLazyGetBackupUploadListQuery,
  usePostBackupOperationByKindDismissMutation,
  useGetBackupOperationQuery,
  useLazyGetBackupOperationQuery,
  useDeleteBackupByTokenDownloadByNameMutation,
  usePostBackupUploadLinkMutation,
  useGetDnsQuery,
  useLazyGetDnsQuery,
  usePutDnsMutation,
  useGetDnsOverridesQuery,
  useLazyGetDnsOverridesQuery,
  usePutDnsOverridesMutation,
  useGetDeviceUpdateFirmwareQuery,
  useLazyGetDeviceUpdateFirmwareQuery,
  useGetDeviceUpdateLauncherQuery,
  useLazyGetDeviceUpdateLauncherQuery,
  useGetDiskinfoQuery,
  useLazyGetDiskinfoQuery,
  useDeleteFirmwareByNameMutation,
  usePutFirmwareByNameMutation,
  useGetFirmwareQuery,
  useLazyGetFirmwareQuery,
  useGetFirmwareUploadByIdStatusQuery,
  useLazyGetFirmwareUploadByIdStatusQuery,
  usePutFirmwareUploadByIdInterruptMutation,
  useGetFirmwareUploadByIdJoinQuery,
  useLazyGetFirmwareUploadByIdJoinQuery,
  useGetFirmwareUploadListQuery,
  useLazyGetFirmwareUploadListQuery,
  usePostFirmwareUploadByNameMutation,
  usePostFirmwareLinkMutation,
  useGetInfoQuery,
  useLazyGetInfoQuery,
  useGetInfoBasicQuery,
  useLazyGetInfoBasicQuery,
  usePutInfoAliasMutation,
  useGetIssuesQuery,
  useLazyGetIssuesQuery,
  useGetLicenseQuery,
  useLazyGetLicenseQuery,
  usePostLicenseMutation,
  useGetLoadQuery,
  useLazyGetLoadQuery,
  usePostLoginMutation,
  useDeleteModulesByIdMutation,
  usePutModulesByIdMutation,
  useDeleteModulesByNameUpdateErrorMutation,
  useGetModulesDiskUsageQuery,
  useLazyGetModulesDiskUsageQuery,
  useGetModulesUploadByIdStatusQuery,
  useLazyGetModulesUploadByIdStatusQuery,
  useGetModulesQuery,
  useLazyGetModulesQuery,
  usePostModulesMutation,
  usePutModulesUploadByIdInterruptMutation,
  useGetModulesUploadByIdJoinQuery,
  useLazyGetModulesUploadByIdJoinQuery,
  useGetModulesUploadListQuery,
  useLazyGetModulesUploadListQuery,
  usePostModulesLinkMutation,
  usePostNetworkAcceptMutation,
  usePostNetworkDeclineMutation,
  useGetNetworkQuery,
  useLazyGetNetworkQuery,
  usePutNetworkMutation,
  usePutNetworkTryByDelayMutation,
  usePutNetworkTryMutation,
  useGetPortAccessQuery,
  useLazyGetPortAccessQuery,
  usePutPortAccessMutation,
  usePostPoweroffMutation,
  usePostRebootMutation,
  usePostRoleGrantsByRoleMutation,
  useDeleteRoleGrantsByRoleMutation,
  usePutRoleGrantsByRoleMutation,
  useGetRoleAvailableModulesQuery,
  useLazyGetRoleAvailableModulesQuery,
  useGetRoleQuery,
  useLazyGetRoleQuery,
  useDeleteServicesByIdMutation,
  useGetServicesQuery,
  useLazyGetServicesQuery,
  useGetServicesBasicQuery,
  useLazyGetServicesBasicQuery,
  usePutServicesByIdByCommandMutation,
  usePostTimeNtpByHostMutation,
  useDeleteTimeNtpByHostMutation,
  useGetTimeQuery,
  useLazyGetTimeQuery,
  useGetTimeTimezoneListQuery,
  useLazyGetTimeTimezoneListQuery,
  usePutTimeDatetimeMutation,
  usePutTimeTimezoneMutation,
  usePutTimeNtpServerByStateMutation,
  usePutTimeNtpByStateMutation,
  usePostTokensMutation,
  useGetTokensQuery,
  useLazyGetTokensQuery,
  useDeleteTokensByIdMutation,
  usePutTokensByIdMutation,
  usePostUploadProbeLinkMutation,
  usePostUserMutation,
  useDeleteUserMutation,
  useGetUserQuery,
  useLazyGetUserQuery,
  usePutUserMutation,
  usePutUserByUsernamePermissionsMutation,
  useGetVtunQuery,
  useLazyGetVtunQuery,
  usePutVtunMutation,
} = injectedRtkApi;
